import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import {
  GET_DOC_BUFFERED_DATA,
  GET_EAPP_PROCESS_HISTORY_DATA,
  GET_LIST_OF_VALUE_DATA,
  GET_PRE_CANDIDATE_DETAIL_DATA,
} from './constants';
import {
  setEappProcessHistoryDataAction,
  setListOfValueDataAction,
} from './actions';
import {
  getEappProcessHistoryService,
  getPreCandidateDetailService,
} from '@services/eRecruitment';
import { loadingRequest, loadingSuccess } from '@stores/global/actions';
import { GlobalModal } from '@components/molecules/PopupModal/GlobalModal';
import { ErrorLevelConfig } from '@core/configureStore/ErrorLevelConfig';
import { hasValue } from '@helpers/utils/utils';
import {
  getDocBufferedDataService,
  getListOfValueService,
} from '@services/ePromotion.js';
import { setPreCandidateDataAction } from '@stores/eRecruitment/actions.js';

export function* getListOfValue({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getListOfValueService, payload);
    yield put(loadingSuccess());

    yield put(setListOfValueDataAction(response));
  } catch (err) {
    yield put(loadingSuccess());
    console.error(err);
    GlobalModal.openOnce({
      title: 'Error',
      message: ErrorLevelConfig.SAGA.FETCH_ERROR,
      onOk: () => {
        // Do nothing
      },
    });
  }
}

export function* getPreCandidateDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getPreCandidateDetailService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setPreCandidateDataAction(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* getEappProcessHistoryDetail({ payload }) {
  try {
    yield put(loadingRequest());
    const response = yield call(getEappProcessHistoryService, payload);
    if (hasValue(response) && response.status === 'SUCCESS') {
      yield put(setEappProcessHistoryDataAction(response.data));
    }
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export function* getDocBufferedData({ payload, callback }) {
  try {
    const { docId } = payload;
    if (!docId) return;

    yield put(loadingRequest());
    const response = yield call(getDocBufferedDataService, payload);
    if (callback) callback(response);
    yield put(loadingSuccess());
  } catch (err) {
    console.error(err);
    yield put(loadingSuccess());
    GlobalModal.openOnce({ ...err, title: ErrorLevelConfig.SAGA.FETCH_ERROR });
  }
}

export default function* ePromotionSaga() {
  yield takeLatest(GET_LIST_OF_VALUE_DATA, getListOfValue);
  yield takeEvery(GET_PRE_CANDIDATE_DETAIL_DATA, getPreCandidateDetail);
  yield takeLatest(GET_EAPP_PROCESS_HISTORY_DATA, getEappProcessHistoryDetail);
  yield takeEvery(GET_DOC_BUFFERED_DATA, getDocBufferedData);
}
